import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m.685 9.79-.578 2.197a3.18 3.18 0 0 0 .56 2.767A3.18 3.18 0 0 0 3.203 16H8.6v-1.6H6.999a1.6 1.6 0 0 1-1.6-1.6v-1.6a1.6 1.6 0 0 1 1.6-1.6h1.6V8H3.006a2.4 2.4 0 0 0-2.32 1.79M6.999 0c-1.654 0-3 1.346-3 3 0 1.655 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m4.8 16h-1.6v-3.2h-3.2v-1.6h3.2V8h1.6v3.2h3.2v1.6h-3.2z"
    }, null, -1)
  ])))
}
export default { render: render }